import { Outlet } from 'react-router-dom';
import { TopNav } from '@/components/layout/TopNav';

export function AppLayout() {
  return (
    <div className="min-h-screen">
      <TopNav />
      <main className="py-8">
        <Outlet />
      </main>
    </div>
  );
}
